import { apply } from "ol-mapbox-style";
import LayerGroup from "ol/layer/Group";
import TileLayer from "ol/layer/Tile";
import XYZ from "ol/source/XYZ";
import { useContext, useEffect } from "react";
import MapContext from "./MapContext";

export enum Maps {
  TOPO = "nl-cartiqo-topo",
  OSM = "openstreetmap",
  LUFOZOMER = "2025_ortho25",
  LUFOWINTER = "2025_orthoHR",
}

const zIndex = 0;

function MapTilerLayer({ style }: { style: Maps }) {
  const { map } = useContext(MapContext);
  useEffect(() => {
    if (map) {
      if ([Maps.LUFOZOMER, Maps.LUFOWINTER].includes(style)) {
        const options = {
          attributions:
            'Open data via <a href="https://www.pdok.nl/">pdok.nl</a>',
          projection: "EPSG:3857",
          maxZoom: 19,
          url: `https://service.pdok.nl/hwh/luchtfotorgb/wmts/v1_0/${style}/EPSG:3857/{z}/{x}/{y}.jpeg?&request=GetTile&service=wmts`,
        };
        let tileBaseLayer = new TileLayer({
          zIndex: zIndex,
          source: new XYZ(options),
        });
        map?.addLayer(tileBaseLayer);
        return () => {
          map?.removeLayer(tileBaseLayer);
        };
      } else {
        let vtGroup: LayerGroup | undefined;
        const addVectorLayer = async () => {
          vtGroup = new LayerGroup();
          await apply(vtGroup, `/tiler/maps/${style}/style.json`);
          map?.addLayer(vtGroup);
        };
        addVectorLayer();
        return () => {
          if (vtGroup) map.removeLayer(vtGroup);
        };
      }
    }
  }, [map, style]);
  return null;
}

export default MapTilerLayer;
